import React, { useState, useEffect } from "react";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import Sidebar from "../components/Sidebar";
import "./Editwidget.css";
import { RiLoaderFill } from "react-icons/ri";
import { FiX } from "react-icons/fi";
import { FaStar } from "react-icons/fa";

import {
  GetwidgetById,
  EditWedgetAPI,
  GetProductStatus,
  GetPincodeProduct,
  GetProductCatWithoutPage,
  GetProductSubCatWithoutPage,
  EditWedgetProduct,
  GetPageNumber,
  api_url,
  updateProductsInWidget,
} from "../apiconfig/authService";
import { toast, ToastContainer } from "react-toastify";

function EditWedget(props) {
  const navigate = useNavigate();
  const { id } = useParams();
  const widgetid = id;
  const [editedEmployeeData, setEditedEmployeeData] = useState({});
  const [statusData, setStatusData] = useState([]);
  const [pagenumber, setPagenumber] = useState();
  const [product, setProduct] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [categoryID, setCategoryID] = useState(-1);
  const [subcategoryID, setSubcategoryID] = useState(-1);
  const [visibleSubcategories, setVisibleSubcategories] = useState([]);
  const [refetchData, setRefetchData] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const setProductViewMessage = props.setMessage;
  const [prevproduct, setPrevproduct] = useState([]);
  const [selectedWidgets, setSelectedWidgets] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [previouscategory, setPreviouscategory] = useState([]);
  const [previoustypecategory, setPrevioustypecategory] = useState([]);
  const [previoussubcategory, setPreviousSubcategory] = useState();
  const [type, setType] = useState(null);
  const [isShowSelectedProducts, setIsShowSelectedProducts] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [productData, setProductData] = useState({ products: [] });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await GetwidgetById(
          id,
          localStorage.getItem("accessToken")
        );
        const pageNumberData = await GetPageNumber(
          localStorage.getItem("accessToken")
        );

        setPrevproduct(response.data.widget.products || []);
        setEditedEmployeeData(response.data.widget);
        setType(response.data.widget.type);
        setPagenumber(pageNumberData.data);
        setPreviouscategory(response.data.categories || []);
        setPreviousSubcategory(response.data.subcategories || []);
        setPrevioustypecategory(response.data.widget.category || []);
        setSelectedWidgets(response.data.widget.pagenumber || []);
      } catch (error) {
        console.error("Error fetching widget data:", error);
        toast.error("Error loading widget data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        const pagenumber = await GetPageNumber(
          localStorage.getItem("accessToken")
        );
        const productData = await GetPincodeProduct(
          search,
          localStorage.getItem("accessToken"),
          categoryID,
          subcategoryID
        );

        setProduct(productData.data.products.items || []);
        setStatusData(statusResponse.data);
        setPagenumber(pagenumber.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [id, search, refetchData, categoryID, subcategoryID]);

  useEffect(() => {
    (async () => {
      try {
        const categoryResponse = await GetProductCatWithoutPage(
          localStorage.getItem("accessToken")
        );
        const subCategoryResponse = await GetProductSubCatWithoutPage(
          localStorage.getItem("accessToken")
        );

        setCategories(categoryResponse.data.categories);
        setSubcategories(subCategoryResponse.data.subcategories);
      } catch (error) {
        console.error("Error loading categories:", error);
      }
    })();
  }, []);

  const handleProductChange = (selectedOptions) => {
    setProductData({
      products: selectedOptions.map((option) => ({
        value: option.value,
        label: option.label,
        image: option.image,
      })),
    });
  };

  const handleDiscardClick = () => {
    navigate("/wedget");
  };

  const handleSubcategoryIDChange = (event) => {
    const selectedSubcategoryID = parseInt(event.target.value, 10);
    setSubcategoryID(selectedSubcategoryID);

    const products = product.filter(
      (product) => product.subcategoryid === selectedSubcategoryID
    );
    setIsShowSelectedProducts(true);
    setProductData({
      products: products.map((product) => ({
        value: product._id,
        label: product.name,
        image: product.imageurl,
      })),
    });
  };

  const handleCategoryIDChange = (e) => {
    const newCategoryID = Number(e.target.value);
    setCategoryID(newCategoryID);
    setSubcategoryID(-1);
    setPrevproduct([]);
    setPreviousSubcategory([]);
    setProductData({ products: [] });
  };

  const handleSearchBoxSubmit = (event) => {
    event.preventDefault();
    setPage(1);
    setRefetchData(!refetchData);
  };

  const productOptions = product.map((item) => ({
    value: item._id,
    label: item.name,
    image: item.imageurl,
    weight: item.weight,
  }));

  const handleRemoveProduct = async (productid) => {

    setLoading(true);
    try {
      const widgetId = widgetid;
      const response = await fetch(
        `${api_url}/wedgetTitle/updateProductsToWidget/${widgetId}/products/${productid}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      if (response.ok) {
        setPrevproduct((prevProducts) =>
          prevProducts.filter((product) => product._id !== productid)
        );
        setProductViewMessage("Product removed successfully!");
        toast.success("Product Removed Successfully");
      } else {
        const errorData = await response.json();
        toast.error(
          errorData.error || "Failed to remove product. Please try again."
        );
      }
    } catch (error) {
      console.error("Error removing product:", error);
      toast.error("An error occurred while removing the product.");
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveCategory = async (categoryid) => {
    setLoading(true);
    try {
      const id = widgetid;
      const response = await fetch(
        `${api_url}/wedgetTitle/removeCategoryFromWidget/${id}/category/${categoryid}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      if (response.ok) {
        setPrevioustypecategory((prevCategories) =>
          prevCategories.filter((cat) => cat._id !== categoryid)
        );
        setProductViewMessage("Category removed successfully!");
        toast.success("Category Removed Successfully!");
      } else {
        const errorData = await response.json();
        toast.error(
          errorData.error || "Failed to remove category. Please try again."
        );
      }
    } catch (error) {
      console.error("Error removing category:", error);
      toast.error("An error occurred while removing the category.");
    } finally {
      setLoading(false);
    }
  };

  const handleTypeChange = (e) => {
    const newType = e.target.value;
    setType(newType);

    setEditedEmployeeData({
      ...editedEmployeeData,
      type: newType,
    });

    // Reset relevant states based on type change
    if (newType === "category") {
      setProductData({ products: [] });
      setCategoryID(-1);
    } else if (newType === "product") {
      setSelectedCategories([]);
    }
  };

  const handlePositionChange = (e) => {
    const value = e.target.value;

    if (value === "") {
      setEditedEmployeeData({
        ...editedEmployeeData,
        position: "",
      });
      return;
    }

    const numValue = parseInt(value, 10);
    if (!isNaN(numValue) && numValue >= 1) {
      setEditedEmployeeData({
        ...editedEmployeeData,
        position: numValue,
      });
    }
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    // Frontend Validations
    if (!editedEmployeeData.title || editedEmployeeData.title.trim() === "") {
      toast.error("Widget title is required!");
      return;
    }

    if (!editedEmployeeData.type || editedEmployeeData.type === "") {
      toast.error("Widget type is required!");
      return;
    }

    if (!editedEmployeeData.position || editedEmployeeData.position === "") {
      toast.error("Position is required!");
      return;
    }

    if (!/^\d+$/.test(editedEmployeeData.position.toString())) {
      toast.error("Position must be a valid number!");
      return;
    }

    if (
      !editedEmployeeData.pagenumber ||
      editedEmployeeData.pagenumber.length === 0
    ) {
      toast.error("At least one page must be selected!");
      return;
    }

    // Type-specific validations
    if (type === "category") {
      const totalCategories = [
        ...(selectedCategories || []),
        ...(previoustypecategory || []).map((cat) => cat._id),
      ];
      const uniqueCategories = [...new Set(totalCategories)];

      if (uniqueCategories.length === 0) {
        toast.error("Select at least one category!");
        return;
      }
    }

    if (type === "product") {
      const totalProducts = [
        ...(productData?.products || []).map((p) => p.value),
        ...(prevproduct || []).map((p) => p._id),
      ];
      const uniqueProducts = [...new Set(totalProducts)];

      if (uniqueProducts.length === 0) {
        toast.error("Select at least one product!");
        return;
      }
    }

    try {
      setEditLoading(true);

      // Prepare category payload based on type
      let categoryPayload = [];
      if (type === "category") {
        const existingCategoryIds = (previoustypecategory || []).map(
          (item) => item._idc
        );
        const allCategoryIds = [
          ...(selectedCategories || []),
          ...existingCategoryIds,
        ];
        categoryPayload = [...new Set(allCategoryIds)];
      }

      // Prepare products payload based on type
      let productsPayload = [];
      if (type === "product") {
        const existingProductIds = (prevproduct || []).map((item) => item._id);
        const newlySelectedIds = (productData?.products || []).map(
          (item) => item.value
        );
        productsPayload = [
          ...new Set([...existingProductIds, ...newlySelectedIds]),
        ];
      }

      const {
        _id: id,
        title,
        statusid,
        position,
        pagenumber,
      } = editedEmployeeData;

      // Prepare payload for widget update
      const widgetUpdatePayload = {
        id,
        title: title.trim(),
        statusid,
        type,
        pagenumber,
        category: categoryPayload,
        products: productsPayload,
        position: position.toString(),
      };


      // Call the API to update widget
      const response = await EditWedgetAPI(
        widgetUpdatePayload,
        localStorage.getItem("accessToken")
      );

      if (response.status === 200) {
        setProductViewMessage("Widget updated successfully!");
        toast.success("Widget Updated Successfully!");
        navigate("/wedget");
      } else {
        throw new Error("Failed to update widget");
      }
    } catch (err) {
      console.error("Error updating widget:", err);
      toast.error(
        err.response?.data?.error ||
          "An error occurred while updating the widget. Please try again."
      );
    } finally {
      setEditLoading(false);
    }
  };

  useEffect(() => {
    if (previouscategory?.length > 0) {
      const defaultCategoryID = previouscategory[0].categoryid;
      setCategoryID(defaultCategoryID);

      const subcategoriesForCategory = subcategories.filter(
        (item) => item.categoryid === defaultCategoryID
      );

      setVisibleSubcategories(subcategoriesForCategory);
    }
  }, [previouscategory, subcategories]);

  const combinedOptions = [
    ...previouscategory.map((prevCat) => ({
      value: prevCat.categoryid,
      label: prevCat.name,
    })),
    ...categories.map((cat) => ({
      value: cat.categoryid,
      label: cat.name,
    })),
  ].reduce((uniqueOptions, item) => {
    if (!uniqueOptions.some((opt) => opt.value === item.value)) {
      uniqueOptions.push(item);
    }
    return uniqueOptions;
  }, []);

  useEffect(() => {
    if (previoussubcategory?.length > 0) {
      setSubcategoryID(previoussubcategory[0]?.subcategoryid);
    }
  }, [previoussubcategory]);

  const combinedSubcategories = [
    ...(previoussubcategory?.map((prevSub) => ({
      value: prevSub?.subcategoryid,
      label: prevSub?.name,
    })) || []),

    ...(visibleSubcategories?.map((subCat) => ({
      value: subCat?.subcategoryid,
      label: subCat?.name,
    })) || []),
  ].reduce((uniqueOptions, item) => {
    if (item && !uniqueOptions.some((opt) => opt.value === item.value)) {
      uniqueOptions.push(item);
    }
    return uniqueOptions;
  }, []);

  const isFormDisabled = editLoading || loading;

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Widget</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/wedget" className="btn btn-primary px-4">
              View All
            </NavLink>
          </div>
        </div>

        {loading ? (
          <div className="d-flex align-items-center justify-content-center">
            <RiLoaderFill
              size={40}
              className="text-success spin-animation text-center"
            />
          </div>
        ) : (
          <div className="personal-info tab-pane active storetab">
            <div className="row">
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <div className="d-flex">
                  <label htmlFor="title">Widget Title</label>
                  <FaStar size={7} className="text-danger" />
                </div>
                <input
                  type="text"
                  disabled={isFormDisabled}
                  onChange={(e) =>
                    setEditedEmployeeData({
                      ...editedEmployeeData,
                      title: e.target.value,
                    })
                  }
                  value={editedEmployeeData.title || ""}
                  className="form-control custom-input my-2"
                  id="title"
                  placeholder="Enter Widget Title"
                />
              </div>

              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <div className="d-flex">
                  <label htmlFor="floatingInput">Page Name</label>
                  <FaStar size={7} className="text-danger" />
                </div>
                <Select
                  isMulti
                  isDisabled={isFormDisabled}
                  options={pagenumber?.map((item) => ({
                    value: item.pagenumber,
                    label: item.pagename,
                  }))}
                  value={selectedWidgets
                    .map((pageNumber) => {
                      const option = pagenumber?.find(
                        (item) => item.pagenumber === pageNumber
                      );
                      return option
                        ? { value: option.pagenumber, label: option.pagename }
                        : null;
                    })
                    .filter((option) => option !== null)}
                  onChange={(selectedOptions) => {
                    setSelectedWidgets(
                      selectedOptions.map((option) => option.value)
                    );
                    setEditedEmployeeData((prevData) => ({
                      ...prevData,
                      pagenumber: selectedOptions.map((option) => option.value),
                    }));
                  }}
                  className="basic-multi-select my-3"
                  classNamePrefix="select"
                  placeholder="Select Pages..."
                />
              </div>

              <div className="form-group col-sm-12 col-lg-12 mb-3">
                <label htmlFor="floatingInput">Status</label>
                <select
                  className="form-select custom-input"
                  disabled={isFormDisabled}
                  onChange={(e) =>
                    setEditedEmployeeData({
                      ...editedEmployeeData,
                      statusid: Number(e.target.value),
                    })
                  }
                  value={editedEmployeeData?.statusid || ""}
                >
                  {statusData.map((item) => (
                    <option key={item.statusid} value={item.statusid}>
                      {item.status}
                    </option>
                  ))}
                </select>
              </div>

              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="d-flex">
                    <label htmlFor="floatingInput">Type</label>
                    <FaStar size={7} className="text-danger" />
                  </div>
                  <select
                    className="form-select custom-input my-2"
                    disabled={isFormDisabled}
                    onChange={handleTypeChange}
                    value={editedEmployeeData?.type || ""}
                  >
                    <option value="" disabled>
                      Select Type
                    </option>
                    <option value="category">Category</option>
                    <option value="product">Product</option>
                  </select>
                </div>

                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="d-flex">
                    <label htmlFor="brandName">Position</label>
                    <FaStar size={7} className="text-danger" />
                  </div>
                  <input
                    type="number"
                    disabled={isFormDisabled}
                    value={editedEmployeeData.position || ""}
                    onChange={handlePositionChange}
                    className="form-control custom-input my-2"
                    id="widget"
                    placeholder="Enter Widget Position (must be positive)"
                    min={1}
                  />
                </div>
              </div>

              {/* Category Section */}
              {type && (
                <form className="sForm" onSubmit={handleSearchBoxSubmit}>
                  <div className="row">
                    <div className="form-group col-sm-12 col-lg-6 mb-3">
                      <div className="d-flex">
                        <label htmlFor="floatingInput">
                          {type === "category"
                            ? "Categories"
                            : "Category (for filtering products)"}
                        </label>
                        <FaStar size={7} className="text-danger" />
                      </div>
                      {type === "category" ? (
                        <Select
                          isMulti
                          closeMenuOnSelect={false}
                          isDisabled={isFormDisabled}
                          options={[
                            ...categories.map((cat) => ({
                              value: cat._id,
                              label: cat.name,
                            })),
                            ...(previoustypecategory?.map((prevCat) => ({
                              value: prevCat._id,
                              label: prevCat.name,
                            })) || []),
                          ].reduce((uniqueOptions, item) => {
                            if (
                              !uniqueOptions.some(
                                (opt) => opt.value === item.value
                              )
                            ) {
                              uniqueOptions.push(item);
                            }
                            return uniqueOptions;
                          }, [])}
                          value={[
                            ...selectedCategories.map((categoryId) => {
                              const matchedCategory = [
                                ...(categories || []),
                                ...(previoustypecategory || []),
                              ].find((item) => item._id === categoryId);
                              return matchedCategory
                                ? {
                                    value: matchedCategory._id,
                                    label: matchedCategory.name,
                                  }
                                : null;
                            }),
                            ...previoustypecategory.map((prevCat) => ({
                              value: prevCat._id,
                              label: prevCat.name,
                            })),
                          ].filter(
                            (item, index, self) =>
                              item &&
                              self.findIndex((v) => v.value === item.value) ===
                                index
                          )}
                          onChange={(selectedOptions) => {
                            const selectedValues = selectedOptions.map(
                              (option) => option.value
                            );
                            setSelectedCategories(selectedValues);
                          }}
                          placeholder="Select Categories"
                          className="custom-select my-2"
                        />
                      ) : (
                        <select
                          id="categorySelect"
                          className="form-select my-3"
                          disabled={isFormDisabled}
                          value={categoryID}
                          onChange={handleCategoryIDChange}
                        >
                          <option value={-1}>
                            Select Category for Product Filtering
                          </option>
                          {combinedOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                  </div>
                </form>
              )}

              {/* Product Selection - Only show for product type */}
              {type === "product" && (
                <div className="form-group col-sm-12 col-lg-12 mb-3">
                  <div className="d-flex">
                    <label htmlFor="productSelect">Select Products</label>
                    <FaStar size={7} className="text-danger" />
                  </div>
                  {categoryID !== -1 ? (
                    <Select
                      options={productOptions}
                      isMulti
                      isDisabled={isFormDisabled}
                      onChange={handleProductChange}
                      closeMenuOnSelect={false}
                      onInputChange={(inputValue) => setSearch(inputValue)}
                      filterOption={null}
                      value={productData.products}
                      getOptionLabel={(option) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={option.image}
                            alt={option.label}
                            style={{ width: 20, height: 20, marginRight: 10 }}
                          />
                          <span>{option.label}</span>
                          <span
                            style={{
                              color: "#757575",
                              fontSize: "14px",
                              marginLeft: "15px",
                            }}
                          >
                            ({option.weight})
                          </span>
                        </div>
                      )}
                      getOptionValue={(option) => option.value}
                      placeholder="Search and Select Products"
                      className="my-2"
                    />
                  ) : (
                    <div className="alert alert-info my-2">
                      Please select a category first to filter and select
                      products.
                    </div>
                  )}
                </div>
              )}

              {/* Display existing products for product type */}
              {type === "product" && prevproduct && prevproduct.length > 0 && (
                <div className="mb-3">
                  <h6>Current Products:</h6>
                  <div className="d-flex flex-wrap">
                    {prevproduct.map((item) => (
                      <div
                        key={item._id}
                        className="position-relative d-inline-block m-3"
                        style={{ width: "100px", height: "80px" }}
                      >
                        <img
                          src={item.imageurl}
                          alt={item.name || "Product Image"}
                          style={{ width: "80px", height: "70px" }}
                          className="img-thumbnail"
                        />
                        <p
                          style={{
                            textAlign: "center",
                            marginTop: "10px",
                            fontSize: "12px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            width: "100%",
                            cursor: "pointer",
                          }}
                          title={item.name}
                        >
                          {item.name}
                        </p>
                        <button
                          type="button"
                          className="btn btn-danger btn-sm position-absolute top-0 end-0"
                          disabled={isFormDisabled}
                          style={{
                            borderRadius: "70%",
                            padding: "2px 2px",
                            transform: "translate(-5%, -60%)",
                          }}
                          onClick={() => handleRemoveProduct(item._id)}
                        >
                          <FiX size={18} />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Display existing categories for category type */}
              {type === "category" &&
                previoustypecategory &&
                previoustypecategory.length > 0 && (
                  <div className="mb-5">
                    <h6 className="mb-3">Current Categories:</h6>
                    <div className="d-flex flex-wrap">
                      {previoustypecategory.map((item) => (
                        <div
                          key={item._id}
                          className="position-relative d-inline-block m-1"
                          style={{ width: "100px", height: "80px" }}
                        >
                          <img
                            src={`${api_url}/product/category/getCategoryImage/${item.image}`}
                            alt={item.name || "Category Image"}
                            style={{ width: "80px", height: "70px" }}
                            className="img-thumbnail"
                          />
                          <p
                            style={{
                              textAlign: "center",
                              marginTop: "10px",
                              fontSize: "12px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              width: "100%",
                            }}
                          >
                            {item.name}
                          </p>
                          <button
                            type="button"
                            className="btn btn-danger btn-sm position-absolute d-flex align-items-center justify-content-center top-0 end-0"
                            disabled={isFormDisabled}
                            style={{
                              borderRadius: "70%",
                              padding: "2px 2px",
                              transform: "translate(-5%, -60%)",
                            }}
                            onClick={() => handleRemoveCategory(item._id)}
                          >
                            <FiX size={18} />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

              <div className="row mt-2">
                <div className="col-12 d-flex gap-2" style={{ height: "40px" }}>
                  <button
                    type="button"
                    onClick={handleDiscardClick}
                    disabled={isFormDisabled}
                    className="btn btn-danger save-btn text-uppercase"
                    style={{ height: "100%", minWidth: "80px" }}
                  >
                    Discard
                  </button>

                  {editLoading ? (
                    <div
                      className="btn btn-primary loader-active save-btn"
                      style={{ height: "100%", minWidth: "80px" }}
                    >
                      <RiLoaderFill
                        size={20}
                        className="spin-animation"
                        color="white"
                      />
                    </div>
                  ) : (
                    <button
                      type="submit"
                      onClick={handleSubmitClick}
                      disabled={isFormDisabled}
                      className="btn btn-primary save-btn text-uppercase"
                      style={{ height: "100%", minWidth: "80px" }}
                    >
                      Save
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <ToastContainer />
    </div>
  );
}

export default EditWedget;
